import React from "react";
import { ThemedPopupView } from "./view";
import { styles } from "./styles";

export class ThemedPopup extends React.Component {
  render() {
    return <ThemedPopupView {...this.props} styles={styles} />;
  }
}
